export const nonLettersRegEx = /\W/g;

type User = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
};

export const nameInitials = (user: User): string =>
  // The spat operator uses the string iterator internally which works better with unicode characters
  // so use that instead of just charAt(0)
  {
    const filteredName = user.first_name?.replace(nonLettersRegEx, '') ?? '';
    const filteredLastName = user.last_name?.replace(nonLettersRegEx, '') ?? '';

    return (
      [filteredName, filteredLastName]
        .map((item) => [...(item ?? '')].at(0)?.toUpperCase() ?? '')
        .join('') ||
      (user.email?.[0]?.toUpperCase() ?? '')
    );
  };
